import axios from "axios";
import Cookies from "js-cookie";

const baseUrl = process.env.REACT_APP_API_BASE_URL || "https://flavorist.app";

const apiClient = axios.create({
  baseURL: baseUrl, 
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

// Add request interceptor for authorization
apiClient.interceptors.request.use(
  (config) => {
    const token = Cookies.get("authToken");
    if (token) {
      config.headers.Authorization = `${token}`;
    } else {
      console.log("Authorization token is missing.");
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (!error.response) {
      alert(
        "A network error occurred. Please check your internet connection or server CORS settings."
      );
      window.location.href = "/";
      return;
    }

    if (error.response?.status === 401 || error.response?.status === 403) {
      // Remove token before redirecting
      Cookies.remove("authToken"); 
      console.log("Unauthorized or forbidden. Redirecting to login...");
      
      // Use Navigate instead of window.location.href to avoid full page reload
      window.location.replace("/");
    }

    return Promise.reject(error);
  }
);

export default apiClient;
